/* jshint ignore:start */
/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

//array.prototype.find polyfill
// https://tc39.github.io/ecma262/#sec-array.prototype.find
if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
        value: function (predicate) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }

            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            var thisArg = arguments[1];

            // 5. Let k be 0.
            var k = 0;

            // 6. Repeat, while k < len
            while (k < len) {
                // a. Let Pk be ! ToString(k).
                // b. Let kValue be ? Get(O, Pk).
                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                // d. If testResult is true, return kValue.
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return kValue;
                }
                // e. Increase k by 1.
                k++;
            }

            // 7. Return undefined.
            return undefined;
        },
        configurable: true,
        writable: true
    });
}

(function ($) {

    var getUrlParameter = function getUrlParameter (param) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === param) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }

        //if nothing found, return empty string
        return '';
    };

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {
                // JavaScript to be fired on all pages

                // variables from php -> php_vars
                var navigationImages = php_vars.navigationImages;

                /**
                 * Primary Navigation Start
                 */

                // Add extra wrapper around first sub-menu
                $.each($('.nav > .menu-item'), function (key, element) {

                    var subMenu = $(element).children('.sub-menu');

                    $(element).append('<div class="sub-menu-wrapper"></div>');
                    $(element).children('.sub-menu-wrapper').append($(subMenu));
                });

                // Add navigation images
                var mainNavItems = $('.nav-primary .nav-image');
                $.each(navigationImages, function (key, element) {

                    // create div element with image inside
                    var navImage = '<div class="nav-image-container"><div class="image-holder"><div class="image-container"><div class="nav-image" style="background-image: url(' + element.url + ')"></div></div></div></div>';

                    var hint = '<div class="hint">< Bitte - wählen Sie eine Sparte</div>';

                    var navElement = $('.nav-primary .' + key + ' > .sub-menu-wrapper ')[0];
                    $(navElement).prepend($(navImage));
                    if (key === 'nav-image-sparten') {
                        $(navElement).append($(hint));
                    }
                });

                // Add submenu - chevron
                $.each($('.sub-menu a'), function (key, element) {
                    if ($(element).siblings('.sub-menu').length !== 0) {
                        $(element).append('<i class="icon-chevron-right"></i>');
                    }
                });

                // Add hint
                // $('sub-menu-wrapper').append('<div>< Bitte wählen Sie eine Sparte</div>');

                // Hover function, only for large devices
                $('.nav-primary .menu-item').on('mouseenter', function (e) {

                    if ($(window).width() >= 1367) {
                        $(this).attr('data-hover', 'running');
                        $(this).addClass('hover');
                        //toggle only if submenu is available
                        if ($(this).children('.sub-menu-wrapper').children('.sub-menu').length > 0) {
                            $(this).children('.sub-menu-wrapper').stop().slideDown();
                        }

                        //sub sub menu
                        $(this).children('.sub-menu').stop().slideDown();
                    }
                });
                $('.nav-primary .menu-item').on('mouseleave', function (e) {

                    if ($(window).width() >= 1367) {
                        $(this).attr('data-hover', 'running');
                        $(this).removeClass('hover');
                        //toggle only if submenu is available
                        if ($(this).children('.sub-menu-wrapper').children('.sub-menu').length > 0) {
                            $(this).children('.sub-menu-wrapper').stop().slideUp();
                        }

                        //sub sub menu
                        $(this).children('.sub-menu').stop().slideUp();
                    }
                });

                //touch navigation
                $('.nav-primary .menu-item').on('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    if ($(this).children('.sub-menu-wrapper').children('.sub-menu').length > 0 && !$(this).hasClass('hover')) {
                        $('.nav-primary #menu-primary-navigation > .menu-item').removeClass('hover active');
                        $('.sub-menu-wrapper').slideUp();
                        $('.nav-primary #menu-primary-navigation .sub-menu .sub-menu').slideUp();
                        $('.nav-primary #menu-primary-navigation .sub-menu .menu-item').removeClass('hover active');
                        $(this).children('.sub-menu-wrapper').stop().slideToggle();
                        $(this).toggleClass('hover');
                    } else if ($(this).children('.sub-menu').length > 0 && !$(this).hasClass('hover')) {
                        $('.nav-primary #menu-primary-navigation .sub-menu .sub-menu').slideUp();
                        $('.nav-primary #menu-primary-navigation .sub-menu .menu-item').removeClass('hover active');
                        $(this).children('.sub-menu').stop().slideToggle();
                        $(this).toggleClass('hover');
                    } else {
                        window.location.href = $(this).children('a').attr('href');
                    }
                });

                //close touch navigation with click outside navigation
                $('body').on('click', function () {
                    $('.sub-menu-wrapper').slideUp();
                    $('.sub-menu-wrapper').removeClass('hover');
                    $('.sub-menu-wrapper > .sub-menu .sub-menu').slideUp();
                    $('.sub-menu-wrapper > .sub-menu .sub-menu').removeClass('hover');
                });

                // add submenu toggle button if submenu is available
                var allMenuItems = $('.sub-menu-wrapper');
                $.each(allMenuItems, function (key, element) {
                    if ($(this).children('.sub-menu').length > 0) {
                        $('<i class="icon-chevron-right green"></i>').appendTo($(element).siblings('a'));
                    }
                });

                //submenu toggler only for mobile/tablet
                $('.icon-chevron-right').on('click', function (e) {
                    e.preventDefault();

                    $(this).closest('.menu-item').toggleClass('hover');

                    if ($(this).closest('.menu-item').children('.sub-menu-wrapper').find('.sub-menu').length > 0) {
                        $(this).closest('.menu-item').children('.sub-menu-wrapper').slideToggle();
                    }
                    //sub sub menu
                    $(this).closest('.menu-item').children('.sub-menu').stop().slideToggle();
                });

                //Nav Burger
                $('.hamburger').on('click', function () {
                    $(this).toggleClass('is-active');
                    $('body').toggleClass('nav-active');
                    $('.nav-primary *').removeClass('hover');
                    $('.nav-primary').slideToggle(400).toggleClass('nav-active');
                });

                //Set active nav
                var current = window.location.href.replace(/https?:\/\//i, "");
                $('.nav-primary a').each(function () {
                    var $this = $(this);
                    // if the current path is like this link, make it active
                    var indexOf = $this.attr('href').indexOf(current);
                    if (indexOf !== -1 && indexOf + current.length === $this.attr('href').length) {
                        var elementActive = $this;
                        var traverseUp = true;
                        do {
                            $(elementActive).addClass('active');
                            elementActive = $(elementActive).parent();
                            if ($(elementActive).attr('id') === 'menu-primary-navigation') {
                                traverseUp = false;
                            }
                        } while (traverseUp);
                    }
                });

                /**
                 * Primary Navigation End
                 */

                /**
                 * Global Elements
                 */

                    //Heading with text
                var background = $('.section-heading-text .heading-bg');
                if (background.length > 0) {
                    resizeBackground();
                    $(window).on('resize', function () {
                        resizeBackground();
                    });

                    function resizeBackground () {
                        var leftOffset = $('.section-heading-text .text-heading').offset().left - $(window).scrollLeft();
                        var widthToAdd = ($(window).width() - $(background).width()) / 2;
                        $(background).css({
                            'width': $(window).width() - widthToAdd,
                            'left': leftOffset * -1
                        });
                    }
                }

                // Dropdown
                $('.rohrdorf-dropdown').on('click', function () {
                    $(this).children('.dropdown-container').stop().slideToggle();
                    $(this).toggleClass('active');
                });

                var aufMorgenBauenCotainerHeight = $('.section-auf-morgen-bauen .content-container').outerHeight();
                var aufMorgenBauenWrapperHeight = $('.section-auf-morgen-bauen .content-wrapper').outerHeight();
                var aufMorgenBauenPadding = ($('.section-auf-morgen-bauen').outerHeight() - aufMorgenBauenCotainerHeight - aufMorgenBauenWrapperHeight) * -1 + 125;
                if ($(window).width() >= 1200) {
                    $('.section-auf-morgen-bauen').css('padding-bottom', aufMorgenBauenPadding);
                }

                // Der einstieg bei Rohrdorfer hover
                $('.section-career-grid-einstieg .column-container').on('hover', function () {
                    $(this).find('.image-hover').toggleClass('hovered');
                });

                // Error Wrapper
                var errorWrappers = $('.error-wrapper[data-error=true]');
                $(errorWrappers).fadeIn(400);

                //posts on mobile
                function addMobileElipsis () {
                    if ($(window).width() <= 575) {
                        $('.single-sticky-post .post-content').each(function () {
                            $(this).css({
                                'overflow': 'hidden',
                                'text-overflow': 'ellipsis',
                                'display': '-webkit-box',
                                'line-height': '1.5rem',
                                'max-height': '10.5rem',
                                '-webkit-line-clamp': 7,
                                '-webkit-box-orient': 'vertical'
                            });
                        });
                    }
                }

                addMobileElipsis();

                /**
                 * Hotbutton Doughnut
                 */

                //hover and click event for the doughnut buttons
                $('.icon-wrapper').on('click mouseover', function () {
                    if (!$(this).hasClass('active')) {
                        var parentSection = $(this).closest('section');
                        var target = $(this).attr('data-target');

                        //deactivate previous buttons
                        $(parentSection).find('.icon-wrapper').removeClass('active');
                        $(parentSection).find('.doughnut-text').hide();
                        $(parentSection).find('.icon-line').hide();

                        //activate triggered button
                        $(this).addClass('active');
                        $('.doughnut-text[data-target=' + target + ']').fadeIn(400);
                        $('.icon-line[data-target=' + target + ']').fadeIn(400);
                    }
                });

                //in case there are more than one doughnut we have to this with section id
                var doughnutSections = $('.section-hotbutton-doughnut');

                function doughnutInit () {
                    $.each(doughnutSections, function () {
                        var sectionID = $(this).attr('id');

                        distributeFields(sectionID);
                        $(this).find('.icon-wrapper').fadeIn(200);
                        var firstIcon = $(this).find('.icon-wrapper')[0];
                        $(firstIcon).trigger('click');
                    });
                }

                doughnutInit();
                $(window).on('resize', function () {
                    doughnutInit();
                });

                /**
                 * Hotbutton Grid
                 */
                    //get items per row

                var itemsPerRow = hotButtonItemPerGrid();
                $(window).on('resize', function () {
                    itemsPerRow = hotButtonItemPerGrid();
                    // already active hotbutton?
                    var activeHotbutton = $('.hotbutton-wrapper.active');
                    var oldItemsPerRow = $(activeHotbutton).attr('data-per-row');
                    if (itemsPerRow != oldItemsPerRow) {
                        $('.hotbutton-wrapper.active').removeClass('active').trigger('click touchstart');
                    }
                });

                //click event for hotbutton
                if ($(window).width() < 768) {
                    var flag = false;
                    $('.hotbutton-wrapper').on('mousedown touchstart', function () {
                        //only if not already active
                        if (!flag) {

                            flag = true;
                            setTimeout(function () {
                                setTimeout(function () {
                                    flag = false;
                                }, 250);
                            });

                            if (!$(this).hasClass('active')) {
                                var $activeWrappers = $('.hotbutton-wrapper');
                                var $activeContainer = $('.hotbutton-text-column.active');
                                //get data target
                                var target = $(this).attr('data-target');
                                //find position of clicked element
                                var $allButtons = $('.hotbutton-wrapper');
                                var allButtonsArray = [];
                                $.each($allButtons, function (key, element) {
                                    allButtonsArray.push($(element).attr('data-target'));
                                });
                                var position = $.inArray($(this).attr('data-target'), allButtonsArray);
                                //calc position to insert text-container
                                var newPosition = Math.floor(position / itemsPerRow);
                                //get text container with target
                                var $textContainer = $('.hotbutton-text-column[data-target=' + target + ']');
                                //move container to itemsperrow
                                var allHotbuttonColumns = $('.hotbutton-column');
                                var insertAfter = (itemsPerRow * newPosition) + itemsPerRow - 1;
                                if (insertAfter > $(allHotbuttonColumns).size()) {
                                    insertAfter = $(allHotbuttonColumns).size() - 1;
                                }
                                $textContainer.insertAfter($(allHotbuttonColumns)[insertAfter]);
                                //show container
                                $(this).addClass('active').attr('data-per-row', itemsPerRow);
                                $textContainer.slideDown(400, function () {

                                    $([
                                        document.documentElement,
                                        document.body
                                    ]).animate({
                                        scrollTop: $(this).offset().top - $('header').outerHeight() - 200
                                    }, 400);
                                });
                                $textContainer.addClass('active');

                                $activeWrappers.removeClass('active');
                                $(this).addClass('active');
                                $activeContainer.removeClass('active');
                                $activeContainer.hide();
                            }

                        }
                        return false;
                    });
                } else if ($(window).width() >= 768) {
                    $('.hotbutton-wrapper').on('click mouseover touchstart', function () {
                        //only if not already active
                        if (!$(this).hasClass('active')) {
                            //hide other text containers
                            $('.hotbutton-wrapper').removeClass('active');
                            $(this).parent().siblings('.hotbutton-text-column').hide();
                            //get data target
                            var target = $(this).attr('data-target');
                            //find position of clicked element
                            var $allButtons = $('.hotbutton-wrapper');
                            var allButtonsArray = [];
                            $.each($allButtons, function (key, element) {
                                allButtonsArray.push($(element).attr('data-target'));
                            });
                            var position = $.inArray($(this).attr('data-target'), allButtonsArray);
                            //calc position to insert text-container
                            var newPosition = Math.floor(position / itemsPerRow);
                            //get text container with target
                            var $textContainer = $('.hotbutton-text-column[data-target=' + target + ']');
                            //move container to itemsperrow
                            var allHotbuttonColumns = $('.hotbutton-column');
                            var insertAfter = (itemsPerRow * newPosition) + itemsPerRow - 1;
                            if (insertAfter > $(allHotbuttonColumns).size()) {
                                insertAfter = $(allHotbuttonColumns).size() - 1;
                            }
                            $textContainer.insertAfter($(allHotbuttonColumns)[insertAfter]);
                            //show container
                            $(this).addClass('active').attr('data-per-row', itemsPerRow);
                            $textContainer.slideDown(400, function () {
                                if ($(window).width() < 1200) {
                                    $([
                                        document.documentElement,
                                        document.body
                                    ]).animate({
                                        scrollTop: $(this).offset().top - $('header').outerHeight() - 325
                                    }, 400);
                                }
                            });
                        }
                    });
                }

                /**
                 * Timeline Section
                 */
                var navClicked = false;

                //initialize swiper
                var timelineSwiper = new Swiper('.swiper-container', {
                    // Optional parameters
                    direction: 'horizontal',
                    loop: false,
                    centeredSlides: false,
                    slidesPerView: 3,
                    spaceBetween: 30,
                    speed: 500,
                    breakpoints: {
                        767: {
                            slidesPerView: 1
                        },
                        1199: {
                            slidesPerView: 2
                        }
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    },
                    on: {
                        init: function () {
                            $('.decade-nav').removeClass('active');
                            var decade = $('.swiper-slide.swiper-slide-active').attr('data-decade');
                            $('.decade-nav[data-decade=' + decade + ']').addClass('active');
                        },
                        transitionEnd: function () {
                            // var decade = $('.swiper-slide.swiper-slide-active').attr('data-decade');
                            // if(!$('.decade-nav[data-decade=' + decade + ']').hasClass('active')) {
                            //     $('.decade-nav[data-decade=' + decade + ']').trigger('click');
                            // }
                        }
                    }
                });

                $('.swiper-button-prev, .swiper-button-next').on('click', function () {
                    navClicked = true;
                });

                //move nav-bullet on click
                function calculateBulletOffset () {
                    var timeLineBullets = $('.timeline-pagination .nav-bullet');
                    var dataMoveNav = (($('.timeline-pagination').outerWidth() - $('.pagination-container').outerWidth())) / ($(timeLineBullets).size() - 3);
                    $(timeLineBullets).children('.decade-nav').attr('data-move-nav', Math.ceil(dataMoveNav));
                }

                calculateBulletOffset();
                $(window).on('resize', function () {
                    calculateBulletOffset();
                    var newOffset = $('.decade-nav.active').attr('data-move-nav') * $('.decade-nav.active').attr('data-index') * -1;
                    $('.timeline-pagination').css('left', newOffset);
                });

                //timeline events
                var prevIndex = 0;
                var prevSlide = 0;
                $('.decade-nav').on('click', function () {

                    //check if clicking left or right, to move navigation
                    var movePagination = 0;
                    if ($(this).attr('data-index') == 0 || $(this).attr('data-index') == 1) {
                        $('.timeline-pagination').css('left', 'initial');
                    } else if ($('.nav-bullet:last-child').children('.decade-nav.last').attr('data-index') == $(this).attr('data-index')) {
                        //do nothing
                        var activeIndex = $('.decade-nav.active').attr('data-index');
                        movePagination = ($('.nav-bullet').length - activeIndex) * $(this).attr('data-move-nav') * -1;
                    } else if ($(this).attr('data-index') > $('.decade-nav.active').attr('data-index')) {
                        //clicked right, move pagination right
                        var activeIndex = $('.decade-nav.active').attr('data-index');
                        if (activeIndex < 1) {
                            activeIndex = 1;
                        }

                        movePagination = ($(this).attr('data-index') - activeIndex) * $(this).attr('data-move-nav') * -1;
                    } else if ($(this).attr('data-index') < $('.decade-nav.active').attr('data-index')) {
                        //clicked left, move pagination left
                        var activeIndex = $('.decade-nav.active').attr('data-index');
                        if (activeIndex < 1) {
                            activeIndex = 1;
                        }

                        movePagination = (activeIndex - $(this).attr('data-index')) * $(this).attr('data-move-nav');
                    }
                    var paginationLeft = parseInt($('.timeline-pagination').css('left')) + movePagination;
                    $('.timeline-pagination').css('left', paginationLeft);

                    $('.decade-nav').removeClass('active');
                    $(this).addClass('active');

                    var swiperSlides = $('.swiper-slide');
                    var decades = [];

                    for (var i = 0; i < swiperSlides.length; i++) {
                        if (!decades.includes(swiperSlides[i].dataset.decade.replace('s', ''))) {
                            decades.push(swiperSlides[i].dataset.decade.replace('s', ''));
                        }
                    }

                    //slide to correct slide
                    var targetslide = $('.swiper-slide[data-decade=' + $(this).attr('data-decade') + ']')[0];

                    // if there is no slides for decade find closest decade
                    var currDecade = $('.decade-nav.active').attr('data-decade').replace('s', '');
                    if (currDecade === '1900') {
                        var number = swiperSlides.length - 3;
                        targetslide = $('.swiper-slide[data-timeline-index=' + number + ']')[0];
                    } else if (!targetslide) {
                        var closest = decades.reduce(function (prev, curr) {
                            return (Math.abs(curr - currDecade) < Math.abs(prev - currDecade) ? curr : prev);
                        });
                        targetslide = $('.swiper-slide[data-decade=' + closest + 's]')[0];
                    }

                    var slideIndex = $(targetslide).attr('data-timeline-index');
                    //check if slideIndex is undefined (e.g. no slides for decade)

                    if (!slideIndex && parseInt(prevIndex) < $(this).attr('data-index')) {
                        slideIndex = parseInt(prevSlide) + 1;
                    }
                    prevIndex = $(this).attr('data-index');
                    prevSlide = slideIndex;
                    if (!navClicked) {
                        timelineSwiper.slideTo(slideIndex, 500, true);
                    }
                    navClicked = false;
                });

                /**
                 * Inpage Navigation Active Menu element
                 */
                var $inpageNavigation = $('.section-inpage-navigation');

                if ($inpageNavigation.size() > 0) {

                    var currentLocation = location.pathname;
                    var $allNavElements = $('.section-inpage-navigation .menu-text');

                    $allNavElements.each(function () {

                        var $this = $(this);
                        var navLink = $this.find('a')[0].pathname;

                        if (navLink === currentLocation) {
                            $this.addClass('active');
                        }
                    });
                }

                /**
                 * Google Maps Filter fields
                 */
                    //autocomplete

                var branches = [];
                var countries = [];

                $.each(php_vars.sparten, function (key, element) {
                    branches.push({
                        label: element.name,
                        value: element.term_id
                    });
                });

                $.each(php_vars.countries, function (key, element) {
                    countries.push({
                        label: element.name,
                        value: element.term_id
                    });
                });

                var branchFilter = $('#mapfilter-branch');
                var countriesFilter = $('#mapfilter-country');

                $(branchFilter).autocomplete({
                    source: branches,
                    minLength: 0,
                    appendTo: $(branchFilter).parent().closest('div'),
                    select: function (event, ui) {
                        event.preventDefault();
                        $(branchFilter).val(ui.item.label);
                        $(branchFilter).attr('data-label-id', ui.item.value);
                    }
                }).on('focus', function () {
                    $(this).autocomplete("search", "");
                });

                $(countriesFilter).autocomplete({
                    source: countries,
                    minLength: 0,
                    appendTo: $(countriesFilter).parent().closest('div'),
                    select: function (event, ui) {
                        event.preventDefault();
                        $(countriesFilter).val(ui.item.label);
                        $(countriesFilter).attr('data-label-id', ui.item.value);
                    }
                }).on('focus', function () {
                    $(this).autocomplete('search', '');
                });

                /**
                 * functions
                 */

                //hotbutton grid item count
                function hotButtonItemPerGrid () {
                    //get number of items per row (changes with responsive)
                    var gridContainerWidth = $('.hotbutton-row').outerWidth();
                    var hotbuttonWidth = $('.hotbutton-column').outerWidth();
                    var itemsPerRow = gridContainerWidth / hotbuttonWidth;

                    return Math.round(itemsPerRow);
                }

                //distributes elements in a circular shape
                function distributeFields (sectionID) {
                    var fields = $('#' + sectionID + ' .icon-wrapper'), lines = $('#' + sectionID + ' .icon-line'),
                        container = $('#' + sectionID + ' .doughnut-container'),
                        width = container.width(), height = container.height(),
                        angle = -1.5708, step = (2 * Math.PI) / fields.length;
                    var radius = width / 2;
                    fields.each(function () {
                        var line = $('.icon-line[data-target=' + $(this).attr('data-target') + ']');

                        //icon coords
                        var iconX = Math.round(width / 2 + radius * Math.cos(angle) - $(this).width() / 2);
                        var iconY = Math.round(height / 2 + radius * Math.sin(angle) - $(this).height() / 2);

                        $(this).css({
                            left: iconX + 'px',
                            top: iconY + 'px'
                        });

                        angle += step;
                    });
                }

                //logout button
                $('.logout').on('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    $.removeCookie('login-session', { path: '/' });
                    location.reload();
                });

                //if logged in show logout button
                var cookie = $.cookie('login-session');
                if (cookie) {
                    $('.section-customer-logout').show();
                }

                /* FAQ Section */
                $('.section-faq .selector-title').on('touchstart click', function () {

                    if (!$(this).hasClass('active')) {
                        var $clickedEl = $(this);
                        var target = $clickedEl.attr('data-target');
                        var $targetEl = $('.section-faq .faq-content-wrapper[data-target=' + target + ']');

                        $('.section-faq .selector-title').removeClass('active');
                        $clickedEl.addClass('active');

                        $('.section-faq .faq-content-wrapper').hide();
                        setFaqHeight($targetEl);
                        setFaqArrowTop($clickedEl, $targetEl);
                        $targetEl.fadeIn(400);
                    }

                });

                //trigger first faq
                var $allFaqElements = $('.section-faq .selector-title');
                if ($allFaqElements.size() > 0) {
                    $($allFaqElements[0]).trigger('click');
                }

                //sets minimum height for faq section
                function setFaqHeight ($contentBox) {
                    var boxHeight = $contentBox.outerHeight();
                    $('.section-faq .faq-container').css('min-height', boxHeight);
                }

                //sets the css top for the arrow
                function setFaqArrowTop ($clickedEl, $contentBox) {
                    var $faqContainer = $('.section-faq .faq-container');
                    var topValue = $clickedEl.offset().top - $faqContainer.offset().top + ($clickedEl.outerHeight() / 2) - 35;
                    var $faqArrow = $contentBox.find('.faq-arrow');

                    $faqArrow.css('top', topValue);
                }

                /* FAQ End*/

            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },
        // Home page
        'home': {
            init: function () {
                // JavaScript to be fired on the home page
            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function () {
                // JavaScript to be fired on the about us page
            }
        },
        // Aapplication page.
        'bewerbung': {
            init: function () {
                // JavaScript to be fired on the applicateion (bewerbung) page
                //get application id (if one is set) and set it as value for input field
                var applicationID = getUrlParameter('applicationID');
                if (applicationID) {
                    $('#appl-id').val(applicationID);
                } else {
                    $('.application-id').hide();
                }
            }
        },
        'page_template_template_company_locations': {
            init: function () {
                // JavaScript to be fired on the about us page
                //Limit container height by minimap height
                var locMaxHeight = $('.minimap').outerHeight() - $('.locations-heading').outerHeight() - 50;
                $('.locations-container').css({ 'max-height': locMaxHeight });

                //Minimap Location marker events
                $('.location-marker').on('click', function () {
                    var target = $(this).data('target-werk');
                    selectStandorte(target, true);
                });

                //Standorte location events
                $('.werk-container').on('click', function () {
                    var target = $(this).data('target-werk');
                    var targetInfoWrapper = $(this).data('target-werk');

                    var infoContainer = $('.werk-info-wrapper[data-target-werk=' + targetInfoWrapper + ']');
                    if ($(window).width() < 992) {
                        var sectionHeight = $($('.section-branch-locations')[0]).outerHeight();
                        $('.section-branch-locations').css('height', $(infoContainer).outerHeight() + sectionHeight - 150);
                    } else {
                        var miniMapHeight = $('.minimap-container').outerHeight();
                        var infoContainerHeight = $(infoContainer).outerHeight() + 150;
                        $('.section-branch-locations').css('height', (miniMapHeight > infoContainerHeight) ? miniMapHeight : infoContainerHeight);
                    }
                    infoContainer.fadeIn();

                    selectStandorte(target, false);
                });

                // Werk Info wrapper close button
                $('.close-button').on('click', function () {
                    $(this).closest('.werk-info-wrapper').fadeOut(function () {
                        $('.section-branch-locations').css('height', 'auto');
                    });
                });

                /**
                 * Functions
                 */

                function selectStandorte (target, mapClick) {

                    //make all "Werke" Inactive and targeted ones active and sort to top
                    $('.werk-container').removeClass('active');
                    $('.werk-container[data-target-werk=' + target + ']').addClass('active').prependTo($('.locations-container'));
                    $('.location-marker').removeClass('active');
                    $('.location-marker[data-target-werk=' + target + ']').addClass('active');
                    if (mapClick) {
                        $('.werk-info-wrapper').fadeOut(function () {
                            $('.section-branch-locations').css('height', 'auto');
                        });
                    }
                }
            }
        },
        //Products Archive page
        'post_type_archive_products': {
            init: function () {

            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        'page_template_template_news': {
            init: function () {

                function addMobileElipsis () {
                    if ($(window).width() <= 575) {
                        $('.single-sticky-post .post-content').each(function () {
                            $(this).css({
                                'overflow': 'hidden',
                                'text-overflow': 'ellipsis',
                                'display': '-webkit-box',
                                'line-height': '1.5rem',
                                'max-height': '10.5rem',
                                '-webkit-line-clamp': 7,
                                '-webkit-box-orient': 'vertical'
                            });
                        });
                    }
                }

                // JavaScript to be fired on the news page template
                /**
                 * Page Setup
                 */
                var pagingOffset = 0;
                var postsPerPage = 6;
                getFilteredPosts('');

                /**
                 * Button events
                 */

                //filter button click event
                $('.filter-button').on('click', function () {

                    var selected = jQuery(this);

                    $('.filter-button').each(function (index, button) {
                        button = jQuery(button);
                        button.toggleClass(
                            'active',
                            button.is(selected)
                        );
                    });

                    //remove previous posts
                    $('.single-sticky-post').remove();

                    //reset paging offset
                    pagingOffset = 0;

                    //get filtered posts
                    getFilteredPosts();
                });

                //load more button click event
                $('.load-more').on('click', function () {
                    getFilteredPosts();
                });

                /**
                 * functions
                 */

                    //gets posts from api filtered by current selected filter
                var newsAjax;

                function getFilteredPosts () {

                    var filter = $('.filter-wrapper.active');
                    var catString = '';
                    if (filter) {
                        $.each(filter, function () {
                            catString += $(this).attr('data-target') + ',';
                        });
                    }

                    //do stuff during loading time
                    $('.no-more-posts').hide();
                    $('.load-more').hide();
                    $('.show-on-load').show();
                    //////////

                    var apiUrl = php_vars.baseUrl + '/wp-json/wp/v2/posts?order=desc&orderby=date&categories_exclude=676,683&per_page=' + postsPerPage + '&offset=' + pagingOffset;

                    if (catString) {
                        apiUrl += '&cat_relation=AND&categories=' + catString;
                    }

                    //get posts from apiV2
                    if (newsAjax) {
                        newsAjax.abort();
                        newsAjax = undefined;
                    }

                    newsAjax = $.ajax({
                        type: 'GET',
                        url: apiUrl,
                        success: function (response) {
                            addFilteredPostsToDom(response);
                            pagingOffset += postsPerPage;
                        },
                        error: function (request, textStatus, errorThrown) {
                            console.log(errorThrown);
                            //implement something
                        }
                    });
                }

                function addFilteredPostsToDom (response) {

                    var allPosts = [];

                    //loop over elements and append to container
                    //loop over elements and append to container
                    var targetBlanc = $('.section-rohrdorfer-news-archive').attr('data-target-blanc');
                    if (targetBlanc) {
                        targetBlanc = 'target="_blanc"';
                    } else {
                        targetBlanc = '';
                    }
                    $.each(response, function (key, element) {

                        var category = '';
                        if (element.full_category[0].name) {
                            category = element.full_category[0].name;
                        }

                        var dateTime = element.date;
                        var dateObject = new Date(dateTime);

                        var postDate = ('0' + dateObject.getDate()).slice(-2) + '.' + ('0' + (dateObject.getMonth() + 1)).slice(-2) + '.' + dateObject.getFullYear();

                        //setup post element
                        var fullContent = element.content.rendered.replace(/(<([^>]+)>)/ig, '');
                        var strippedContent = fullContent.substring(0, 350);

                        var $singlePost = $('<div class="col-md-6 col-xl-4 single-sticky-post">' +
                            '<a class="single-post-link" href="' + element.link + '" ' + targetBlanc + '>' +
                            '<div class="image-holder">' +
                            '<div class="image-container">' +
                            '<div class="post-image" style="background-image: url(' + element.featured_media_url.url + ');"></div>' +
                            '<div class="category-icon"></div>' +
                            '</div>' +
                            '</div>' +
                            '<div class="content-container">' +
                            '<div class="post-meta2">' +
                            '<p class="h4 post-category">' + category + '</p>' +
                            '<p class="post-date">' + postDate + '</p>' +
                            '</div>' +
                            '<p class="h3 post-title">' + element.title.rendered + '</p>' +
                            // '<div class="post-content">' + strippedContent + '...' + '</div>' +
                            '<span class="read-more"></span>' +
                            '</div>' +
                            '</a>' +
                            '</div>').hide();

                        allPosts.push($singlePost);
                    });

                    //append post
                    $('.news-container').append(allPosts);
                    $('.single-sticky-post').fadeIn(400);

                    //check if there are more posts, otherwhise hide button
                    if (response.length < 6) {
                        $('.load-more').hide();
                        $('.no-more-posts').fadeIn(400);
                    } else {
                        $('.load-more').fadeIn(400);
                    }

                    //do stuff after loading time
                    $('.show-on-load').hide();
                    ////////////////

                    addMobileElipsis();
                }
            }
        },
        'page_template_template_positions': {
            init: function () {
                // JavaScript to be fired on the news page template

                var isExecutedFromGetFromLocalStorage = false;
                var isNEZPage = false;
                const currentPath = $(location).attr('pathname');
                if (currentPath.indexOf('netzeroemissionlabs') !== -1) {
                    isNEZPage = true;
                }
                var nezFeld_value = 0;
                var nezFeld_label = '';

                /**
                 * Filter Setup
                 */

                var level = [];
                var feld = [];
                var standort = [];

                // number of all post get from /wp-json/wp/v2/positions
                var numPosts = 0;

                $.each(php_vars.level, function (key, element) {
                    level.push({
                        label: element.name,
                        value: element.term_id,
                        count: element.count
                    });
                });

                $.each(php_vars.felder, function (key, element) {
                    feld.push({
                        label: element.name,
                        value: element.term_id,
                        count: element.count
                    });
                    if (isNEZPage && element.name === 'Net Zero Emission Labs') {
                        nezFeld_value = element.term_id.toString();
                        nezFeld_label = element.name;
                    }
                });

                $.each(php_vars.standorte, function (key, element) {
                    standort.push({
                        label: element.name,
                        value: element.term_id,
                        land: element.land,
                        count: element.count
                    });
                });

                var levelFilter = $('#product-filter-level');
                var feldFilter = $('#product-filter-feld');
                var standortFilter = $('#product-filter-standort');

                var anzahlOffeneStellen = $('#anzahl-offene-stellen');
                var filterTiles = $('#filter-tiles');

                /**
                 * Page Setup
                 */


                var selectedLevel = [];
                var selectedFeld = [];
                var selectedStandort = [];

                $.each(level, function (key, value) {
                    $(levelFilter).append($('<option>', {
                        value: value.value,
                        text: value.label + ' (' + value.count + ')'
                    }));
                });

                $.each(feld, function (key, value) {
                    $(feldFilter).append($('<option>', {
                        value: value.value,
                        text: value.label + ' (' + value.count + ')'
                    }));
                });

                var groupBy = function (xs, key) {
                    return xs.reduce(function (rv, x) {
                        (rv[x[key]] = rv[x[key]] || []).push(x);
                        return rv;
                    }, {});
                };

                var standortGrupped = groupBy(standort, 'land');
                $.each(standortGrupped, function (key, value) {
                    var groupName = key;
                    if (groupName === 'null') {
                        groupName = 'Nicht zugeordnet';
                    }
                    var group = $('<optgroup label="' + groupName + '" />');
                    $.each(value, function () {
                        group.append($('<option>', {
                            value: this.value,
                            text: this.label + ' (' + this.count + ')'
                        }));
                    });
                    group.appendTo(standortFilter);
                });

                $(document).on('changed.bs.select', '#product-filter-level', function (e, clickedIndex, isSelected, oldValue) {
                    if (!isExecutedFromGetFromLocalStorage) {
                        $('.sop-positions').innerHTML = '';
                        pushToSelected(e, oldValue, clickedIndex, selectedLevel, level);
                        removeShowMoreBtn();
                        getFilteredPositions(10);
                        pushToLocalStorage(selectedLevel, selectedFeld, selectedStandort);
                    }
                });

                $(document).on('changed.bs.select', '#product-filter-feld', function (e, clickedIndex, isSelected, oldValue) {
                    if (!isExecutedFromGetFromLocalStorage) {
                        $('.sop-positions').innerHTML = '';
                        pushToSelected(e, oldValue, clickedIndex, selectedFeld, feld);
                        removeShowMoreBtn();
                        getFilteredPositions(10);
                        pushToLocalStorage(selectedLevel, selectedFeld, selectedStandort);
                    }
                });

                $(document).on('changed.bs.select', '#product-filter-standort', function (e, clickedIndex, isSelected, oldValue) {
                    if (!isExecutedFromGetFromLocalStorage) {
                        $('.sop-positions').innerHTML = '';
                        pushToSelected(e, oldValue, clickedIndex, selectedStandort, standort);
                        removeShowMoreBtn();
                        getFilteredPositions(10);
                        pushToLocalStorage(selectedLevel, selectedFeld, selectedStandort);
                    }
                });

                /**
                 * functions
                 */

                function getFromLocalStorage () {
                    isExecutedFromGetFromLocalStorage = true;
                    var data = JSON.parse(localStorage.getItem('jobFilter'));

                    selectedLevel = data.selectedLevel;
                    selectedFeld = data.selectedFeld;
                    selectedStandort = data.selectedStandord;

                    var selectedLevelValues = [];
                    for (var i = 0; i < selectedLevel.length; i++) {
                        selectedLevelValues.push(selectedLevel[i].value);
                    }

                    var selectedFeldValues = [];
                    for (var j = 0; j < selectedFeld.length; j++) {
                        selectedFeldValues.push(selectedFeld[j].value);
                    }

                    var selectedStandortValues = [];
                    for (var k = 0; k < selectedStandort.length; k++) {
                        selectedStandortValues.push(selectedStandort[k].value);
                    }

                    $('#product-filter-level').selectpicker('val', selectedLevelValues);
                    $('#product-filter-feld').selectpicker('val', selectedFeldValues);
                    $('#product-filter-standort').selectpicker('val', selectedStandortValues);
                }

                function pushToLocalStorage (selectedLevel, selectedFeld, selectedStandord) {
                    var data = {
                        'selectedLevel': selectedLevel,
                        'selectedFeld': selectedFeld,
                        'selectedStandord': selectedStandord
                    };
                    localStorage.setItem('jobFilter', JSON.stringify(data));
                }

                //gets posts from api filtered by current selected filter
                function getFilteredPositions (num) {

                    //do stuff during loading time
                    $('.no-positions').hide();
                    $('.show-on-load').show();
                    $('.single-position-container').remove();

                    var element;
                    if ($(filterTiles).children().length > 0) {
                        $(filterTiles).empty();
                    }

                    if (!$.isEmptyObject(selectedLevel)) {
                        for (var i = 0; i < selectedLevel.length; i++) {
                            element = '<span id="level-' + selectedLevel[i].value + '" style="border: 1px solid black; border-radius: 5px; padding: 7px; margin-right: 10px;">' + selectedLevel[i].label + '  <span class="unselect" style="cursor: pointer;">X</span></span>';
                            $(filterTiles).append(element);
                        }
                    }

                    if (!$.isEmptyObject(selectedFeld)) {
                        for (var j = 0; j < selectedFeld.length; j++) {
                            element = '<span id="feld-' + selectedFeld[j].value + '" style="border: 1px solid black; border-radius: 5px; padding: 7px; margin-right: 10px;">' + selectedFeld[j].label + '  <span class="unselect" style="cursor: pointer;">X</span></span>';
                            $(filterTiles).append(element);
                        }
                    }

                    if (!$.isEmptyObject(selectedStandort)) {
                        for (var k = 0; k < selectedStandort.length; k++) {
                            element = '<span id="standort-' + selectedStandort[k].value + '" style="display:inline-block; margin-bottom:' +
                                ' 5px;border: 1px solid black; border-radius: 5px; padding: 7px; margin-right: 10px;">' + selectedStandort[k].label + '  <span class="unselect" style="cursor: pointer;">X</span></span>';
                            $(filterTiles).append(element);
                        }
                    }

                    var apiUrl = php_vars.baseUrl + '/wp-json/wp/v2/positions/';
                    var urlUpdated = false;

                    var selectedLevelIds = selectedLevel.map(function (a) {
                        return a.value;
                    });
                    if (!$.isEmptyObject(selectedLevel)) {
                        urlUpdated = true;
                        apiUrl += '?einstiegslevel=' + selectedLevelIds.join(',');
                    }

                    var selectedFeldIds = selectedFeld.map(function (a) {
                        return a.value;
                    });
                    if (!$.isEmptyObject(selectedFeld)) {
                        if (urlUpdated) {
                            apiUrl += '&taetigkeitsfeld=' + selectedFeldIds.join(',');
                        } else {
                            urlUpdated = true;
                            apiUrl += '?taetigkeitsfeld=' + selectedFeldIds.join(',');
                        }
                    }

                    var selectedStandortIds = selectedStandort.map(function (a) {
                        return a.value;
                    });
                    if (!$.isEmptyObject(selectedStandort)) {
                        if (urlUpdated) {
                            apiUrl += '&stellen_standort=' + selectedStandortIds.join(',');
                        } else {
                            urlUpdated = true;
                            apiUrl += '?stellen_standort=' + selectedStandortIds.join(',');
                        }
                    }

                    if (urlUpdated) {
                        apiUrl += '&per_page=' + num;
                    } else {
                        apiUrl += '?per_page=' + num;
                    }

                    // console.log(apiUrl);

                    $.ajax({
                        type: 'GET',
                        url: apiUrl,
                        success: function (response, textStatus, request) {

                            numPosts = request.getResponseHeader('x-wp-total');

                            addPositionsCountToDom(numPosts);

                            addFilteredPositionsToDom(response);

                            if (numPosts >= 10) {
                                loadShowMoreButton();
                            }

                            var $allPositionLocations = $('.single-position-container .position-location');
                            var maxWidth = 0;
                            $allPositionLocations.each(function (index, element) {
                                var outerWidth = $(element).outerWidth();
                                if (outerWidth > maxWidth) {
                                    maxWidth = outerWidth;
                                }
                            });
                        },
                        error: function (request, textStatus, errorThrown) {
                            console.log(errorThrown);
                            //implement something
                        }
                    });
                }

                function pushToSelected (e, oldValue, clickedIndex, selectedArray, allArray) {
                    var selected = $(e.currentTarget).val();
                    var diff = $(selected).not(oldValue).get();
                    var single = $.grep(allArray, function (e) {
                        return e.value == diff;
                    });

                    // remove from selected if it was there
                    if (single.length === 0 && clickedIndex !== null) {
                        const indexId = selectedArray.map(function (x) {
                            return x.value;
                        }).indexOf(allArray[clickedIndex].value);
                        selectedArray.splice(indexId, 1);
                    } else {
                        // add to selected
                        if (single.length === 1) {
                            selectedArray.push({
                                value: diff[0],
                                label: single[0].label
                            });
                        }
                    }
                }

                function pushToSelectedPrefill () {
                    var urlParams = new URLSearchParams(window.location.search);
                    var landParam = urlParams.get('Land');

                    var options = standortFilter.find('optgroup[label="' + landParam + '"] option');
                    $.each(options, function () {
                        this.setAttribute('selected', 'selected');
                        selectedStandort.push({
                            value: this.value,
                            label: this.label
                        });
                    });
                }

                function addPositionsCountToDom (numPosts) {
                    if (numPosts > 0) {
                        $(anzahlOffeneStellen).text('Offene Stellen: ' + numPosts);
                    } else {
                        $(anzahlOffeneStellen).text('Offene Stellen: 0');
                    }
                }

                function addFilteredPositionsToDom (response) {

                    var allPositions = [];

                    var targetBlanc = $('.section-open-positions').attr('data-target-blanc');
                    if (targetBlanc) {
                        targetBlanc = 'target="_blank"';
                    } else {
                        targetBlanc = '';
                    }

                    //loop over elements and append to container
                    if (response.length > 0) {

                        $.each(response, function (key, element) {

                            var cat_icon = {};
                            if (element.cat_icon.url) {
                                cat_icon = element.cat_icon;
                            } else {
                                cat_icon.url = '/wp-content/uploads/2019/07/Kontakt_Icon_Person_Bauarbeiter.png';
                                cat_icon.title = '';
                                cat_icon.alt = '';
                            }

                            //setup post element
                            var contentIcons = element.content_icons || [];
                            var jobLocation = '';
                            if (contentIcons && contentIcons[0]) {
                                jobLocation = contentIcons[0].text.replace(/<\/?[^>]+(>|$)/g, '').split(':')[1];
                            }

                            const fieldIndex = feld.map(function (x) {
                                return x.value;
                            }).indexOf(element.taetigkeitsfeld[0]);

                            var singlePosition = '<div class="single-position-container">' +
                                '<a href="' + element.link + '">' +
                                '<p class="position-title">' +
                                '<img class="cat-icon" src="' + cat_icon.url + '" title="' + cat_icon.title + '" alt="' + cat_icon.alt + '" />' +
                                '<span class="title-text">' +
                                element.title.rendered + '</span>' +
                                '<span class="field-of-activity-text">' +
                                feld[fieldIndex].label + '</span>' +
                                '<span class="position-location"><span>' + jobLocation + '</span></span>' +
                                '</p>' +
                                '</a>' +
                                '<div class="position-content">' +
                                '<div class="icons-container d-flex">';

                            for (var i = 0; i < contentIcons.length; i++) {
                                singlePosition += '<div class="single-icon" style="background-image: url(' + contentIcons[i].icon + ')">' + contentIcons[i].text + '</div>';
                            }
                            ;

                            singlePosition += '</div>' +
                                '<div class="content-wrapper">' + element.content.rendered + '</div>' +
                                '<div class="application-wrapper"><a class="rohrdorf-button" href="' + $('.section-open-positions').attr('data-application-url') + '?applicationID=' + element.application_id + '" ' + targetBlanc + '>Bewerben</a></div>';
                            '</div>' +
                            '</div>';

                            var $singleposition = $(singlePosition);
                            $singleposition.on('click', function () {
                                return;
                                //check if current clicked item is already opened
                                if (!$(this).hasClass('active')) {
                                    //finde already opened item(s) and slide them up
                                    $('.single-position-container').removeClass('active');
                                    $('.single-position-container').find('.position-content').slideUp(400);
                                    //open clicked item and slide down
                                    $(this).addClass('active');
                                    $(this).find('.position-content').slideDown(400);
                                } else {
                                    //if clicked again, close it
                                    $(this).removeClass('active');
                                    $(this).find('.position-content').slideUp(400);
                                }
                            });

                            allPositions.push($singleposition);
                        });

                        //append post
                        $('.sop-positions').append(allPositions);
                        $('.single-position-container').fadeIn(400);
                    } else {
                        $('.no-positions').fadeIn(400);
                    }

                    //do stuff after loading time
                    $('.show-on-load').hide();
                    ////////////////
                }

                function loadShowMoreButton () {
                    var button =
                        '<div class="row" id="show-more-block">' +
                        '<div class="col-12">' +
                        '<div class="float-right">' +
                        '<button class="rohrdorf-button" id="show-more">MEHR STELLEN ANZEIGEN</button>' +
                        '</div>' +
                        '</div>' +
                        '</div>';
                    $('.sop-positions').append(button);
                }

                // unselect unwanted filers
                $(document).on('click', '.unselect', function () {
                    var clicked = $(this).parent().attr('id');
                    var elements = clicked.split('-');
                    var id = elements[1];
                    var label = elements[0];

                    if (label === 'level') {
                        const indexId = selectedLevel.map(function (x) {
                            return x.value;
                        }).indexOf(id);
                        if (indexId > -1) {
                            selectedLevel.splice(indexId, 1);

                            var selectedLevelValues = [];
                            for (var i = 0; i < selectedLevel.length; i++) {
                                selectedLevelValues.push(selectedLevel[i].value);
                            }

                            $('#product-filter-level').selectpicker('val', selectedLevelValues);

                        }
                    } else if (label === 'feld') {
                        const indexId = selectedFeld.map(function (x) {
                            return x.value;
                        }).indexOf(id);
                        if (indexId > -1) {
                            selectedFeld.splice(indexId, 1);

                            var selectedFeldValues = [];
                            for (var j = 0; j < selectedFeld.length; j++) {
                                selectedFeldValues.push(selectedFeld[j].value);
                            }

                            $('#product-filter-feld').selectpicker('val', selectedFeldValues);

                        }
                    } else {
                        const indexId = selectedStandort.map(function (x) {
                            return x.value;
                        }).indexOf(id);
                        if (indexId > -1) {
                            selectedStandort.splice(indexId, 1);

                            var selectedStandortValues = [];
                            for (var k = 0; k < selectedStandort.length; k++) {
                                selectedStandortValues.push(selectedStandort[k].value);
                            }

                            $('#product-filter-standort').selectpicker('val', selectedStandortValues);

                        }
                    }
                    // getFilteredPositions();
                });

                $(document).ready(function () {
                    var urlParams = new URLSearchParams(window.location.search);
                    var landParam = urlParams.get('Land');

                    if (landParam && landParam.length) {
                        localStorage.removeItem('jobFilter');
                    }

                    if (isNEZPage && nezFeld_value) {
                        pushToLocalStorage([], [{ value: nezFeld_value, label: nezFeld_label }], []);
                    } else {
                        pushToLocalStorage([], [], []);
                    }

                    var jobFilter = JSON.parse(localStorage.getItem('jobFilter'));

                    if ((jobFilter !== null)) {
                        if (jobFilter.selectedFeld.length > 0 || jobFilter.selectedLevel.length > 0 || jobFilter.selectedStandord.length > 0) {
                            getFromLocalStorage();
                            isExecutedFromGetFromLocalStorage = false;
                        }
                    } else {
                        pushToSelectedPrefill();
                        removeShowMoreBtn();
                    }

                    getFilteredPositions(10);
                });

                $(document).on('click', '#show-more', function (e) {
                    // e.preventDefault();
                    removeShowMoreBtn();
                    getFilteredPositions(100);
                });

                function removeShowMoreBtn () {
                    var showMoreBtn = $('#show-more-block');
                    var vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
                    if (showMoreBtn.length) {
                        showMoreBtn.remove();
                    }

                    if (!isNEZPage && vw >= 768) {
                        $('html, body').animate({ scrollTop: 800 }, 'slow');
                    }
                    return false;
                }

            }
        },
        // Login Page.
        'page_id_992': {
            init: function () {
                // JavaScript to be fired on the about us page
                var cookie = $.cookie('login-session');
                if (cookie) {
                    window.location.replace(php_vars.baseUrl + '/products/');
                }
            }
        }
    };

    Sage['category'] = Sage['page_template_template_news'];

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
/* jshint ignore:end */

